export interface ITab {
    id: number;
    title: string;
    emptyLabel: string;
}
export const DISTRIBUTION = {
    EVENLY: '2',
    PERCENTAGE: '1',
    CUSTOM: '3',
};
export interface IQty {
    index?: number;
    Select: boolean;
    EquipmentID: string | number;
    EssoRateDetailsSplitId: string | number;
    EquipmentNumber: string;
    DocumentId: string | number;
    DocumentNumber: string;
    CblID: string | number;
    cBLNumber: string;
    BookingSplitId: string | number;
    BookingID: string | number;
    BookingNumber: string;
    QuantityPercentage: string | number;
    ContainerType: string;
    ContainerSize: string;
    SubstitutionType: string;
    SubstitutionSize: string;
    etsId?: string | number;
}
export interface IChargeItems {
    essorateDetailId?: string;
    chargeItem?: number;
    sourceID?: string;
    billToParty: string;
    billToPartyName: string;
    carrierServiceContractCost: string;
    children: any[];
    quantityDistribution?: any[];
    condCurrency: string;
    contractItemNumberCost: string;
    contractNumberCost: string;
    contractNumberRevenue: string;
    contractTypeRevenue: string;
    costAndRevenueDetails: any[];
    displayDistribution: boolean;
    distribution: number;
    documentId: number;
    errorReason: string;
    exchangeRate: string;
    handleError: boolean;
    icbIndicator: string;
    id: number;
    infoRecordCost: string;
    insertBy: string;
    insertDate: string;
    isDeleted: boolean;
    itemCategory: string;
    itemNumber: string;
    itemType: string;
    localCurrency: string;
    materialCode: number;
    materialDescription: string;
    modsStringRevenue: string;
    others: string;
    partyDetails: string;
    passThrough: string;
    payTermsRevenue: string;
    payToParty: number;
    payToPartyName: string;
    pricingDate: string;
    profitCenterRevenue: string;
    purOrgCost: string;
    quantity: string;
    rate: string;
    rowVersion: string;
    sourceType: string;
    status: string;
    total: string;
    totalLocalCurrency: string;
    uom: string;
    updatedBy: string;
    updatedDate: string;
    reasonCode: string;
    exportSalesOrderId: number;
    serviceRenderedAt: string;
    specialPricingCondition: string | boolean;
    netValue: string | number;
    vatPartner: string;
    vatPartnerReasonCodeNo: string;
    AdhocContractualAmendmentIdentifier: string;
    Applicability: string;
    ChargeType: string;
    dynamicFields: string;
    AthenaRateIdentifier: string;
    VatPartnerIdentifier: string;
    VatPartnerValueError: string;
    chargeValidityBased: string;
    contractStartDate: string;
    contractEndDate: string;
    secondaryRateIdentifier: string;
    IsIgnoredOnRateRefresh?: boolean;
    internalReferenceNumber?: string;
    isReadOnly?: boolean;
    division?: string;
}
export interface ICostRevDistribution {
    ItemCategory: string;
    ChargeItems: any[];
}
export const QuantityDistributionModel: IQty = {
    Select: true,
    EquipmentID: '',
    EquipmentNumber: '',
    EssoRateDetailsSplitId: '',
    DocumentId: '',
    DocumentNumber: '',
    CblID: '',
    cBLNumber: '',
    BookingSplitId: '',
    BookingID: '',
    BookingNumber: '',
    QuantityPercentage: '',
    ContainerType: '',
    ContainerSize: '',
    SubstitutionType: '',
    SubstitutionSize: '',
};
export const costRevModel: ICostRevDistribution = {
    ItemCategory: '',
    ChargeItems: [
        {
            id: 0,
            EssorateDetailId: '0',
            Distribution: 2,
            SourceType: '',
            SourceID: '',
            ItemNumber: '',
            ItemType: '',
            ItemCategory: '',
            ModsStringRevenue: '',
            MaterialCode: '',
            MaterialDescription: '',
            Quantity: '',
            Uom: '',
            Rate: '',
            ReasonCode: '',
            RowVersion: '',
            CondCurrency: '',
            PricingDate: '',
            ExchangeRate: '',
            LocalCurrency: '',
            ProfitCenterRevenue: '',
            PayToParty: '',
            BillToParty: '',
            IsDeleted: false,
            IcbIndicator: '',
            PayTermsRevenue: '',
            PurOrgCost: '',
            CarrierServiceContractCost: '',
            ContractNumberCost: '',
            ContractItemNumberCost: '',
            PartyDetails: '',
            InfoRecordCost: '',
            ErrorReason: '',
            PassThrough: '',
            ContractNumberRevenue: '',
            ContractTypeRevenue: '',
            InsertBy: '',
            UpdatedBy: '',
            AdhocContractualAmendmentIdentifier: '',
            Applicability: '',
            ChargeType: '',
            dynamicFields: '',
            AthenaRateIdentifier: '',
            specialPricingCondition: 'N',
            netValue: 0.00,
            VatPartnerIdentifier: '',
            VatPartnerValueError: '',
            chargeValidityBased: '',
            contractStartDate: '',
            contractEndDate: '',
            secondaryRateIdentifier: '',
            QuantityDistribution: [
                {
                    Select: true,
                    EquipmentID: '',
                    EquipmentNumber: '',
                    EssoRateDetailsSplitId: '',
                    DocumentId: '',
                    DocumentNumber: '',
                    CblID: '',
                    cBLNumber: '',
                    BookingSplitId: '',
                    BookingID: '',
                    BookingNumber: '',
                    QuantityPercentage: '',
                    ContainerSize: '',
                    ContainerType: '',
                    SubstitutionSize: '',
                    SubstitutionType: '',
                },
            ],
            children: [],
            serviceRenderedAt: '',
            vatPartner: '',
            vatPartnerReasonCodeNo: '',
        },
    ],
};
